import * as Popover from '@radix-ui/react-popover';
import LexicalInput from '../lexicalInput/LexicalInput.jsx';

const ArgumentFilePopover = ({ align = 'end', children, value, onChange }) => {
  const onPointerDownOutside = (e) => {
    if (e.target.closest('.comp-floating-pane-v2 .pane')) {
      e.stopPropagation();
      e.preventDefault();
    }
  };
  return (
    <Popover.Root>
      <Popover.Trigger asChild>{children}</Popover.Trigger>
      <Popover.Portal container={document.querySelector('.app-pane-section:not(.is-closed)')}>
        <Popover.Content className="argument-file-popover" side="top" align={align} sideOffset={8} onInteractOutside={onPointerDownOutside}>
          <div className="bound-input">
            <div className={'label'}>File Name</div>
            <LexicalInput argKey={'fileName'} value={value} onDebounce={onChange} />
          </div>
        </Popover.Content>
      </Popover.Portal>
    </Popover.Root>
  );
};

export default ArgumentFilePopover;
